// extracted by mini-css-extract-plugin
export default {"uploaded":"styles_uploaded__lRbSM","btn":"styles_btn__UyIj9","textUploaded":"styles_textUploaded__WfX8b"};